<template>
    <view-card headline="공사금액정보" titleCols="auto" titleAlign="baseline" :disabled="disabled">
        <v-col slot="buttons" v-if="!disabled" class="py-0">
            <v-btn small :color="interims.length < 5 ?'secondary' : 'warning'" @click="addInterim">중도금 추가</v-btn>
        </v-col>
        <v-row>
            <v-col :cols="cols" class="py-0">
                <v-text-field v-model="totalAmount" label="총액" placeholder=" " prefix="금" suffix="원" readonly disabled />
            </v-col>
        </v-row>
        <v-divider />
        <v-row>
            <v-col :cols="cols" class="pb-0">
                <v-text-field v-model="downPayment.amount" type="number" label="계약금" placeholder=" " prefix="금" suffix="원" />
            </v-col>
            <v-col :cols="cols" class="pb-0">
                <v-date-field v-model="downPayment.duesAt" label="납입일" placeholder=" " />
            </v-col>
        </v-row>
        <v-divider />
        <template v-for="({ amount, duesAt }, index) in interims">
            <v-row :key="`payment-${index}`">
                <v-col :cols="cols" class="pb-0">
                    <v-text-field
                        :value="amount"
                        @input="
                            (_amount) => {
                                interims[index].amount = _amount;
                                sync();
                            }
                        "
                        type="number"
                        :label="`중도금${index + 1}차`"
                        placeholder=" "
                        prefix="금"
                        suffix="원"
                    />
                </v-col>
                <v-col :cols="cols" class="pb-0">
                    <v-date-field
                        :value="duesAt"
                        @input="
                            (_duesAt) => {
                                interims[index].duesAt = _duesAt;
                                sync();
                            }
                        "
                        label="납입일"
                        placeholder=" "
                    />
                </v-col>
                <v-col v-if="!disabled" cols="1" class="pb-0" align-self="center">
                    <v-row justify="center">
                        <v-icon @click="removeInterim(index)">mdi-minus-circle</v-icon>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider :key="`divider-${index}`" />
        </template>
        <v-row>
            <v-col :cols="cols" class="pb-0">
                <v-text-field v-model="balancePayment.amount" type="number" label="잔금" placeholder=" " prefix="금" suffix="원" />
            </v-col>
            <v-col :cols="cols" class="pb-0">
                <v-date-field v-model="balancePayment.duesAt" label="납입일" placeholder=" " />
            </v-col>
        </v-row>
    </view-card>
</template>
<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import viewCard from "../dumb/view-card.vue";

const initialPayment = {
    type: "중도금",
    amount: null,
    duesAt: null,
};

const initialDownPayment = {
    ...initialPayment,
    type: "계약금",
};

const initialBalancePayment = {
    ...initialPayment,
    type: "잔금",
};

export default {
    components: { viewCard, VDateField },
    props: {
        value: { type: Array, default: [] },
        disabled: { type: Boolean, default: true },
    },
    data() {
        return {
            downPayment: { ...initialDownPayment },
            balancePayment: { ...initialBalancePayment },
            interims: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const paymentPlan = [...this.value].map((item) => {
                item.duesAt = item.duesAt.toDate();
                return item;
            });

            this.downPayment = paymentPlan.find(({ type }) => type == "계약금") || { ...initialDownPayment };

            this.balancePayment = paymentPlan.find(({ type }) => type == "잔금") || { ...initialBalancePayment };

            this.interims = paymentPlan.filter(({ type }) => type == "중도금");
            this.sync();
        },
        sync() {
            const { paymentPlan } = this;
            this.$emit("input", paymentPlan);
        },
        addInterim() {
            if (this.interims.length == 5) alert("중도금은 5차까지만 추가하실 수 있습니다.");
            else {
                this.interims.push({
                    ...initialPayment,
                });
                this.sync();
            }
        },
        removeInterim(index) {
            this.interims.splice(index, 1);
            this.sync();
        },
    },
    computed: {
        totalAmount() {
            return this.paymentPlan.reduce((totalAmount, { amount }) => +totalAmount + +amount, 0).format();
        },
        paymentPlan() {
            const { downPayment, balancePayment, interims } = this;
            return [downPayment, ...interims, balancePayment];
        },
        cols() {
            return this.disabled ? "6" : "5";
        },
    },
};
</script>
